import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr';
import { i18n } from '../../translate/i18n';

export const setServiceTypeFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_SERVICE_TYPE_FILTER,
    serviceTypeFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};
export const fetchServiceTypesSuccess = (serviceTypes) => {
  return {
    type: actionTypes.FETCH_SERVICE_TYPES_SUCCESS,
    serviceTypes: serviceTypes
  };
};

export const requestServiceTypesFail = (error) => {
  return {
    type: actionTypes.REQUEST_SERVICE_TYPES_FAIL,
    error: error
  };
};

export const requestServiceTypesStart = () => {
  return {
    type: actionTypes.REQUEST_SERVICE_TYPES_START
  };
};

export const deleteServiceTypesSuccess = (serviceType) => {
  return {
    type: actionTypes.DELETE_SERVICE_TYPES_SUCCESS,
    serviceType: serviceType
  }
}

export const checkDeleteServiceTypesSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_SERVICE_TYPES_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateServiceTypesSuccess = (serviceType) => {
  return {
    type: actionTypes.UPDATE_SERVICE_TYPES_SUCCESS,
    serviceType: serviceType
  }
}

export const postServiceTypesSuccess = (serviceType) => {
  return {
    type: actionTypes.POST_SERVICE_TYPES_SUCCESS,
    serviceType: serviceType
  }
}

export const fetchServiceTypes = (page, limit, search, order, orderBy) => {

  return dispatch => {
    dispatch(requestServiceTypesStart());
    dispatch(setServiceTypeFilter(page, limit, search, order, orderBy));
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/servicetypes' + queryParams)
      .then(res => {
        dispatch(fetchServiceTypesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestServiceTypesFail(err));
      });
  };
};

export const deleteServiceTypes = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestServiceTypesStart());
      API.put('/servicetypes/' + index + '/delete')
        .then(res => {
          dispatch(deleteServiceTypesSuccess(res.data));
          toastr.success(i18n.t('deleteServiceTypes.toastr'), `${res.data.name}${i18n.t('deleteServiceTypes.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServiceTypesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const checkDeleteServiceTypes = (index) => {
  return dispatch => {
    dispatch(requestServiceTypesStart());
    API.get('/servicetypes/' + index + '/checkdelete')
      .then(res => {
        dispatch(checkDeleteServiceTypesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestServiceTypesFail(err));
      });
  }
}

export const postServiceTypes = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestServiceTypesStart());
      API.post('/servicetypes', body)
        .then(res => {
          dispatch(postServiceTypesSuccess(res.data));
          toastr.success(i18n.t('postServiceTypes.toastr'), `${res.data.name}${i18n.t('postServiceTypes.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServiceTypesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postServiceTypes.toastrErro'), i18n.t('postServiceTypes.toastrErro1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateServiceTypes = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestServiceTypesStart());
      API.put('/servicetypes/' + index, body)
        .then(res => {
          dispatch(updateServiceTypesSuccess(res.data));
          toastr.success(i18n.t('updateServiceTypes.toastr'), `${res.data.name}${i18n.t('updateServiceTypes.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestServiceTypesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateServiceTypes.toastrError'), i18n.t('updateServiceTypes.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}
